import { mode } from '@chakra-ui/theme-tools';

const globalStyles = (props) => ({
  'html, body': {
    fontSize: '14px',
    height: '100%',
    margin: '0px',
    bg: mode('#F5F4F5', '#121212')(props),
  },
  '.mainBg': {
    bg: mode('#F5F4F5', '#121212')(props),
  },
  '.blockBg': {
    bg: mode('White', '#363636')(props),
  },
  '.pageTitle': {
    color: mode('#3F6701', '#fff')(props),
  },
  ' .gridHead': {
    bg: mode('#FFF0EF', '#4B1F1A')(props),
    color: mode('#000', '#fff')(props),
  },
  ' .subHead': {
    bg: mode('#c4c4c4', '#363636')(props),
    color: mode('#000', '#fff')(props),
  },

  ' select,.css-yk16xz-control': {
    borderColor: '#ACABAB !important',
    bg: mode('#F4F4F4 !important', '#363636 !important')(props),
  },
  '.loginBlock input, .loginBlock select,.blockBg input, .blockBg select,.css-yk16xz-control':
    {
      bg: mode('#f4f4f4 !important', '#121212 !important')(props),
      borderColor: '#ACABAB !important',
      // bg: '#F4F4F4',
      borderRadius: '4px',
    },

  '.loginBlock': {
    bg: mode('#fff', '#363636')(props),
  },
  h2: {
    fontSize: '1.1em',
  },
  h1: {
    fontSize: '1.7em',
    fontWeight: 'bold',
  },
  '.error': {
    color: '#B72618',
  },
  '.slick-next:before, .slick-prev:before': {
    color: '#B72618',
  },
  ' :focus': {
    outline: '0 !important',
    boxShadow: '0 0 0 0 rgba(0, 0, 0, 0) !important',
  },
  '.chakra-icon': {
    color: mode('#fff', '#fff')(props),
  },
  '.drawerHead': {
    color: '#fff',
  },
  '.modalHeader': {
    color: '#fff',
    fontSize: '16px !important',
    bg: '#B72618',
  },
  '.modalBody,.modalFooter': {
    bg: mode('#fff', '#121212')(props),
  },
  ' .drawerBody': {
    bg: mode('#fff', '#121212')(props),
  },
  '.grid': {
    maxH: '300px',
    width: { base: '100%', lg: '247px' },

    // w: { base: '100%',  },
    // spacing: '2',
    rounded: 'xl',
    // boxShadow: 'sm',
    m: '1.5',
    bg: mode('#fff', '#121212')(props),
    // align: 'stretch',
    border: '1px solid #ACABAB !important',
  },
  '.drawerBody .grid': {
    bg: mode('#fff', '#363636')(props),
  },
  '.gridHeader': {
    width: '100% !important',
    align: 'flex-start',
    bg: mode('#FFF0EF', '#4B1F1A')(props),
    p: '2',
    roundedTop: 'xl',
    w: { base: '100%', md: '100%' },
    color: mode('Black', 'White')(props),
    height: '36px',
    borderBottom: '1px solid #ACABAB',
  },
  '.gridGrayHeader': {
    width: 'full',
    align: 'flex-start',
    bg: mode('#F0F2F2', '#f1f3f3')(props),
    p: '2',
    roundedTop: 'xl',
    w: '265px',
    color: mode('Black', 'White')(props),
    height: '36px',
  },
  '.gridBottom': {
    bg: mode('#F2F2F2', '#121212')(props),
    p: '2',
    roundedBottom: 'xl',
    // boxShadow: 'md',
    borderTop: '1px solid #ACABAB',
    w: { base: '100%', md: '100%' },
    maxH: '100px',
    mb: '0',
  },
  '.accordionItem': {
    bg: mode('#FFF0EF', '#4B1F1A')(props),
    color: mode('Black', 'White')(props),
    borderBottomWidth: '3px',
    borderColor: 'brand.red',
  },
  '.accordionItem h2': {
    color: mode('#B72618', 'White')(props),
  },
  ' .addresSearchResult': {
    bg: mode('#fff', '#121212')(props),
    color: mode('Black', 'White')(props),
  },
  '.tagItem': {
    mr: '2',
    borderColor: mode('#DCDADA', '#121212')(props),
    bg: mode('#F5F4F5', '#121212')(props),
    borderWidth: '1px ',
    borderRadius: '0 ',
    p: '2 ',
    borderLeftWidth: '3px ',
    borderLeftColor: 'brand.red',
    m: '2 ',
  },
  '.chakra-menu__menu-list': {
    color: '#fff',
  },
  '.addSearchContainer': {
    position: 'absolute',
    top: '70px',
    left: '0px',
    bg: mode('#fff', '#121212')(props),
    border: '1px solid #ACABAB',
    p: '5',
    w: '100%',
    zIndex: '99999',
  },

  '.dashboard': { width: '100%' },
  '.dashboard .grid': {
    height: '350px',
    maxHeight: '350px',
  },
  '.dashboard .col1': {
    width: '60%',
  },
  '.dashboard .col2 ': {
    width: '40%',
    paddingLeft: '30px',
  },
  '.dashboard .grid,.dashboard .gridHeader ': {
    width: '100%',
  },
  '.dashboard th': {
    bg: mode('#e6e6e6', '#121212')(props),
    fontSize: '14px',
    padding: '10px',
  },
  '.dashboard td': {
    padding: '10px',
  },

  '.dahsboardTableGrid': {
    padding: '0px !important',
    marginTop: '10px',
    marginBottom: '10px',
    maxHeight: '260px',
    overflowX: 'auto',
  },
  '.dahsboardTableGrid::-webkit-scrollbar': {
    width: '10px',
  },

  '.dahsboardTableGrid::-webkit-scrollbar-track': {
    background: '#E5E5E5',
    borderRadius: '10px',
  },
  '.dahsboardTableGrid::-webkit-scrollbar-thumb': {
    borderRadius: '10px',
    background: '#CACACA',
    border: '2px solid #E5E5E5',
  },
  '.totalGrid': {
    borderTop: '1px solid #ccc',
    borderBottom: '1px solid #ccc',
    background: mode('#FFF0EF', '#4B1F1A')(props),
    padding: '10px',
  },
  input: {
    borderColor: '#ACABAB !important',
    autocomplete: 'off',
    bg: mode('#F4F4F4 !important', '#363636 !important')(props),
    borderRadius: '4px',
  },
  '.PhoneInput': {
    border: '1px solid #ACABAB',
    borderRadius: '6px',
    padding: '6px',
    bg: mode('#F4F4F4 !important', '#363636 !important')(props),
  },
  '.PhoneInputInput': {
    bg: mode('#F4F4F4 !important', '#363636 !important')(props),
  },
  '.overflow-ellipsis': {
    width: '150px',
    // background-color: '#fff;
    // padding: 15px;
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});
export default globalStyles;
